module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAASlJREFUWEftlzFOwzAYhd+zxMwtGGDpEcLOCuIKJELiAEgNAzMsCYzsnZnhApUY6AAsbByBCT+UUoZaVfgTS6QIe37+/8+frcQmBh4cuD/WC8DlGovICGQ/mHnwHoe44lOswSUDrtAjgB1TUeHa1zwyZVtCIYCarK/YujWuUJN798AIFZ9jIPoB5BqDKCGc+5qnvw6AY207j9mi8Q2EVwsEienHBqa45Nt3vpeBZrIrdALgwtI4yEx8xYNogHmBXCNHZBA2TSDNtgVnrLcBU8MgtDi8S4c8ASQDyUAy8HcMlLfzX7BtCC/lHrfCcNSXcHAA29LbU1EGEsD/MMBCd4Y3QZQMAfequLv6SvZ12903vw26o8wgTHzNs5UA3evFz1ivt2H8erpX+ATF9uMhpJatlQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/anliDetail/jdNewTitle.png
// module id = jooA
// module chunks = 1